import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const StyledModalHeaderIcon = styled(FontAwesomeIcon)`
  font-size: 1.25em;
  margin-right: .6rem;
  width: 1.05em;
  height: 1.05em;
  vertical-align: -0.2em;
`;

export {
  StyledModalHeaderIcon,
};